import axios from 'axios'
import { ForceLogoutErrorCodes, TranslateTestString, SessionResult } from '@/constants'
import {getReCaptchaHeaders} from '@/utils'

function loadFaqs(commit) {
  commit('loading_faq_data')
  axios.get('/faq_topics/').then(resp => {
    commit('set_faq_topics', resp.data)
  }).catch(err => {
    commit('set_faq_topics', [])
    commit('error', err)
  })
}

function loadBackgroundData(commit) {
  loadFaqs(commit)
}

function onSessionStarted(commit, authData) {
  const authToken = authData['auth_token']
  commit('auth_success', authToken)
  loadBackgroundData(commit)
  commit('session', authData.session)
  commit('reset_idle_timer')
}

const actions = {
  get_session({ commit }) {
    return new Promise((resolve, reject) => {
      // get the session data
      axios.get('/sessions/')
        .then(resp => {
          commit('session', resp.data)
          resolve(resp.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  start({ dispatch, commit }, searchParam) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      axios.post('/session/start/', searchParam, { timeout: 60000 })
        .then(resp => {
          onSessionStarted(commit, resp.data)
          resolve(resp.data.session)
        })
        .catch(err => {
          commit('auth_error')
          reject(err)
        })
    })
  },
  authorize({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
      axios.post('/session/auth/', params, { timeout: 60000 })
        .then(resp => {
          onSessionStarted(commit, resp.data)
          resolve(resp.data.session)
        })
        .catch(err => {
          commit('auth_error')
          commit('error', err)
          reject(err)
        })
    })
  },
  session_action({ dispatch, commit, state }, request) {
    console.log('session action')
    console.log(request)

    return new Promise((resolve, reject) => {
      const onSuccess = function(resp) {
        commit('success')
        commit('clear_messages')
        commit('session', resp.data)
        commit('reset_idle_timer')
        resolve(resp.data)
        if (window._mfq && resp.data && resp.data.step) {
          window._mfq.push(['newPageView', `/${resp.data.step_id}/${resp.data.step_slug}`])
        }
      }
      const onError = function(err) {
        commit('clear_messages')
        reject(err)
      }
      const poll = function() {
        axios.get('/sessions/poll/')
          .then(resp => {
            onSuccess(resp)
          })
          .catch(err => {
            if (err.response && err.response.status === 423) {
              waitForStatus()
            } else {
              onError(err)
            }
          })
      }
      const waitForStatus = function() {
        setTimeout(() => poll(), 1000)
      }
      axios.post('/sessions/' + state.session.id.toString() + '/' + request.action + '/',
        request.params, { timeout: 60000 })
        .then(resp => {
          if (resp.status === 202) {
            waitForStatus()
          } else {
            onSuccess(resp)
          }
        })
        .catch(err => {
          if (err.response && err.response.status === 423) {
            waitForStatus()
          } else {
            onError(err)
          }
        })
    })
  },
  verify({ dispatch }, params) {
    return dispatch('session_action', { action: 'verify', params: params })
  },
  match({ dispatch }, params) {
    return dispatch('session_action', { action: 'match', params: params })
  },
  input({ dispatch }, params) {
    return dispatch('session_action', { action: 'input', params: params })
  },
  jump({ dispatch }, params) {
    return dispatch('session_action', { action: 'jump', params: params })
  },
  email({ dispatch }, params) {
    return dispatch('session_action', { action: 'email', params: params })
  },
  undo({ dispatch }) {
    return dispatch('session_action', { action: 'undo', params: {} })
  },
  close({ dispatch }) {
    return dispatch('session_action', { action: 'close', params: {} })
  },
  get_faq({ dispatch }, params) {
    return dispatch('fetch_faq', params)
  },
  initiate_faq_search({dispatch}, query) {
    return dispatch('search_faq', query)
  },
  home({ dispatch, commit, state }) {
    return new Promise((resolve, reject) => {
      console.log('go home')

      if (state.session && state.session['can_go_home']) {
        dispatch('session_action', { action: 'home', params: {} })
          .then(session => {
            resolve(session)
          })
          .catch(err => {
            console.log(err)

            if (err.response && (ForceLogoutErrorCodes.indexOf(err.response.status) >= 0)) {
              commit('logout')
            } else if (err.response && err.response.status === 422) {
              resolve(state.session) // just a warning, so treat as successful
            } else {
              commit('error', err)
              reject(err)
            }
          })
      } else {
        resolve(state.session)
      }
    })
  },
  update_customer({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      axios.patch('/customers/' + state.session.customer.id.toString() + '/', params)
        .then(resp => {
          commit('success')
          commit('customer', resp.data)
          resolve(resp.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  add_credit_card({ commit }, params) {
    let value = getReCaptchaHeaders(params)
    params = value[0]
    let headers = value[1]
    return new Promise((resolve, reject) => {
      axios.post('/payment_sources/add_card/', params, {headers})
        .then(resp => {
          commit('success')
          commit('payment_source', resp.data)
          resolve(resp.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  update_credit_card({ commit }, params) {
    const cardId = params.id
    delete params['id']
    let value = getReCaptchaHeaders(params)
    params = value[0]
    let headers = value[1]
    return new Promise((resolve, reject) => {
      axios.post('/payment_sources/' + cardId.toString() + '/update_card/', params, {headers})
        .then(resp => {
          commit('success')
          commit('payment_source', resp.data)
          resolve(resp.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  get_payment_sources({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.customer && state.customer.payment_sources) {
        resolve(state.customer.payment_sources)
      } else {
        axios.get('/payment_sources/')
          .then(resp => {
            commit('success')
            commit('payment_sources', resp.data)
            resolve(resp.data)
          })
          .catch(err => {
            reject(err)
          })
      }
    })
  },
  get_addresses({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.customer && state.customer.addresses) {
        resolve(state.customer.addresses)
      } else {
        axios.get('/customer_addresses/')
          .then(resp => {
            commit('success')
            commit('addresses', resp.data)
            resolve(resp.data)
          })
          .catch(err => {
            reject(err)
          })
      }
    })
  },
  get_switchable_campaigns({commit, state}) {
    return new Promise((resolve, reject) => {
      if (state.campaign && state.campaign.switchable_campaigns) {
        resolve(state.campaign.switchable_campaigns)
      } else {
        axios.get('/sessions/' + state.session.id.toString() + '/campaigns/')
          .then(resp => {
            commit('success')
            commit('switchable_campaigns', resp.data)
            resolve(resp.data)
          })
          .catch(err => {
            reject(err)
          })
      }
    })
  },
  update_session({commit, state}, data) {
    return new Promise((resolve, reject) => {
      if (!state.session) {
        reject(Error('missing session'))
      } else if ((data.result === state.session.result) && (data.result === SessionResult.Logout)) {
        resolve(state.session)
      } else {
        axios.put('/sessions/' + state.session.id.toString() + '/', data)
          .then(resp => {
            commit('success')
            commit('session', resp.data)
            resolve(state.session)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      }
    })
  },
  wait_for_translation({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      const elem = params.element
      let originalValue = TranslateTestString // check for translation of the default test string
      let observer = null; let timer = null

      if ('translateText' in params) {
        originalValue = params.translateText // translation text passed in, so check for that to change
      }

      function translationCallback() {
        const currentValue = elem.innerText

        if (currentValue && currentValue.indexOf(originalValue) < 0) {
          if (timer) {
            clearTimeout(timer)
          }

          // translator modified our string, so we're ready
          if (observer) {
            observer.disconnect()
          } else {
            elem.removeEventListener('DOMSubtreeModified', translationCallback)
          }

          resolve(currentValue)
        }
      }

      if (state.currentLanguage === 'en') {
        // english language doesn't need translation, so nothing to do - we're ready
        resolve(originalValue)
      } else {
        if (typeof MutationObserver !== 'undefined') {
          observer = new MutationObserver(translationCallback)
          observer.observe(elem, { characterData: true, subtree: true })
        } else {
          elem.addEventListener('DOMSubtreeModified', translationCallback, false)
        }

        if ('timeout' in params) {
          // set a timeout to prevent waiting forever
          timer = setTimeout(function() {
            reject(new Error('Unable to translate language at this time.'))
          }, params.timeout)
        }
      }
    })
  },
  fetch_faq({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      let url = `/faq/${params.slug}/`
      axios.get(url)
        .then(response => {
          commit('success')
          commit('update_selected_faq', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  get_product({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      let url = `/campaign_products/${params.id}/`
      axios.get(url)
        .then(response => {
          commit('success')
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  check_for_ie({commit}) {
    let ieIndex = !!window.navigator.userAgent.match(/(MSIE|Trident)/)
    commit('set_ie_status', ieIndex)
  },
  search_faq({commit, state}, query) {
    return new Promise((resolve, reject) => {
      let queryStrings = []
      for (let key in query) {
        queryStrings.push(encodeURIComponent(key) + '=' + encodeURIComponent(query[key]))
      }
      let url = `/faqs/search/?` + queryStrings.join('&')
      axios.get(url)
        .then(response => {
          commit('success')
          commit('update_faq_search_results', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  fetch_topic_faqs({commit, state}, topicId) {
    return new Promise((resolve) => {
      axios.get('/faqs/', {
        params: {
          topics: topicId
        }
      }).then(resp => {
        commit('update_related_faqs', resp.data)
        commit('ready')
        resolve()
      }).catch(_err => {
        commit('ready')
        resolve()
      })
    })
  },
  get_cart({commit, state}) {
    return new Promise((resolve, reject) => {
      axios.get('/sessions/' + state.session.id.toString() + '/cart/'
      ).then(resp => {
        const cart = resp.data

        if (cart) {
          commit('set_cart', resp.data.items)
        }

        resolve(state.cart)
      }).catch(err => {
        reject(err)
      })
    })
  },
  set_cart({commit, state, getters}, cart) {
    let cartMap = {}
    let normalizedCart = []
    let params = []
    let customerData = {}

    if (cart && cart.length) {
      cart.forEach(item => {
        if (item.quantity) {
          const key = item.campaign_product.id.toString() + '-' + (item.variant ? item.variant.id.toString() : '0')

          if (key in cartMap) {
            cartMap[key].quantity += item.quantity
          } else {
            cartMap[key] = item
          }
        }
      })

      Object.values(cartMap).forEach(item => {
        let bundledVariants = null
        normalizedCart.push(item)

        if (item.bundled_variants && item.bundled_variants.length) {
          bundledVariants = []

          item.bundled_variants.forEach(bundle => {
            bundledVariants.push({variant: bundle.variant.id, quantity: bundle.quantity})
          })
        }
        params.push({
          campaign_product: item.campaign_product.id,
          variant: item.variant ? item.variant.id : null,
          quantity: item.quantity,
          bundled_variants: bundledVariants,
          buy_now_clicked: item.buy_now_clicked ? item.buy_now_clicked : false
        })
      })
      const customer = state.session.customer
      if (customer) {
        customerData = {
          ship_city: customer.ship_city,
          ship_state: customer.ship_state,
          ship_zip: customer.ship_zip
        }
      }
      commit('set_cart', normalizedCart)
    }
    return new Promise((resolve, reject) => {
      axios.post('/sessions/' + state.session.id.toString() + '/cart/',
        {items: params, customer: customerData}, {cancelRequest: true}
      ).then(resp => {
        commit('set_cart', resp.data.items)
        commit('set_shipping_and_tax', resp.data)
        resolve(state.cart)
      }).catch(err => {
        reject(err)
      })
    })
  },
  add_cart({ dispatch, state }, items) {
    let cart = state.cart || []
    if (!(items instanceof Array)) {
      items = [items]
    }
    cart.unshift(...items)
    return dispatch('set_cart', cart)
  },
  set_session_started({commit, state}) {
    return new Promise((resolve, reject) => {
      if (state.session && !state.session.started) {
        axios.post('/sessions/' + state.session.id.toString() + '/start/').then(() => {
          commit('set_session_started')
          resolve(state.session)
        }).catch(err => {
          reject(err)
        })
      } else {
        resolve(state.session)
      }
    })
  },
  load_fulfillments({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios.get('/order_items/' + state.session.selected_item.id.toString() + '/fulfillments/')
        .then(resp => {
          commit('success')
          commit('fulfillment_loaded', resp.data)
          resolve(resp.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  load_shipment_return_label({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      axios.get('/order_items/' + params.item.id.toString() + '/return_label/',
        {params: {qr_code: params.qr_code ? 'true' : ''}}
      ).then(result => {
        console.log(result)
        window.open(result.data['label_url'], '_blank')
        commit('ready')
      }, error => {
        console.log(error)
        commit('critical_error', error)
        commit('ready')
      })
    })
  }
}

export default actions
